import { render, staticRenderFns } from "./PlatformWalletModule.vue?vue&type=template&id=8443487a&"
import script from "./PlatformWalletModule.vue?vue&type=script&lang=js&"
export * from "./PlatformWalletModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports